import { render, staticRenderFns } from "./CurYearField.vue?vue&type=template&id=cf2a8ede&"
import script from "./CurYearField.vue?vue&type=script&lang=ts&"
export * from "./CurYearField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports